module.exports = __webpack_public_path__ + "img/TOS-4.aee03b3f.jpg";